import GroupLayout from "./GroupLayout";

const EuroLayout = () => (
  <GroupLayout
    brandName="Podar"
    logoUrl="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/podar-logo.png"
    
    groupId="10000000022"
    headline="Podar International Group of Institutions"
  />
);

export default EuroLayout;
